import { Badge, Group } from '@mantine/core';
import type { DiffRow } from '../../domain/entityDiff.js';
import { SYNC_STATUS } from '../../domain/status.js';

type Chip = Extract<DiffRow, { kind: 'chips' }>['items'][number];

/** `+` for an item only the after side has, `−` for one only the before side had; the sign carries it, not the ink. */
const SIGN: Record<Chip['side'], string> = { both: '', added: '+', removed: '−' };
const INK: Record<Chip['side'], string> = {
    both: 'gray',
    added: SYNC_STATUS.in_sync.color,
    removed: SYNC_STATUS.missing.color,
};
const SIDE: Record<Chip['side'], string> = { both: 'on both sides', added: 'added', removed: 'removed' };

/** A list of scalars as one row of chips, in the order `diffGroups` gives them. */
export const ValueChips = ({ items }: { items: Chip[] }) => (
    <Group gap={4} wrap="wrap">
        {items.map((item, i) => (
            <Badge
                key={`${item.side}:${item.value}:${i}`}
                size="sm"
                radius="sm"
                tt="none"
                fw={500}
                variant={item.side === 'both' ? 'default' : 'light'}
                color={INK[item.side]}
                aria-label={`${item.value}, ${SIDE[item.side]}`}
            >
                {SIGN[item.side] && <span aria-hidden>{SIGN[item.side]} </span>}
                {item.value}
            </Badge>
        ))}
    </Group>
);
